export class ServiceDefinitionAvailabilitySlotViewModel {
    id: number;
    serviceDefinitionId: number;
    day: number;
    maxRequestsPerDay: number;
    startTime: any;
    endTime: any;
    isDeleted: boolean = false;

    dayName: string;
    startTimeDisplay: string;
    endTimeDisplay: string;
    modalRefIdKey: any;
    rowIndex: number;
}